import React from 'react'
import { FormControl, FormGroup, Grid, Row, Col, ControlLabel, Radio } from 'react-bootstrap'
import i18next from 'i18next'
import linkifyHtml from 'linkifyjs/html'

import styles from './styles/questionnaire.scss'
import illustration from './../assets/images/wopi-wide.png'

export default class WopiSetup extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      information: {
        givenName: '',
        familyName: '',
        age: '',
        sex: null
      },
      isInformationFormValid: false,
      consentGiven: false
    }
  }

  toggleConsentGiven = ({ target }) => {
    this.setState({ consentGiven: target.checked })
  }

  onChange = e => {
    const information = this.state.information
    information[e.target.name] = e.target.value

    this.setState({ information: information }, () =>
      this.setState({
        isInformationFormValid:
          this.state.information.givenName && this.state.information.familyName
      })
    )
  }

  submit = e => {
    e.preventDefault()

    this.props.submitPersonalAndStatisticalInformation(
      this.props.uuid,
      this.state.information.givenName,
      this.state.information.familyName,
      this.state.information.age,
      this.state.information.sex
    )
  }

  render() {
    const phases = [
      () => this.renderIntroduction(),
      () => this.renderConfidentialityAgreement(),
      () => this.renderPersonalInformationForm()
    ]

    return (
      <Grid className={styles.introductionText}>
        <Row>
          <Col md={12}>{phases[this.props.activeSetupPhase]()}</Col>
        </Row>
      </Grid>
    )
  }

  renderIntroduction() {
    return (
      <section className={styles.introductionText}>
        <h1>{i18next.t('what_is_wopi', { lng: this.props.language, ns: 'questionnaire' })}</h1>

        <Row>
          <Col md={10} mdOffset={1}>
            <p>
              {i18next.t('what_is_wopi_description', {
                lng: this.props.language,
                ns: 'questionnaire'
              })}
            </p>

            <p>
              <button
                id="next-button"
                className={styles.button}
                onClick={() => this.props.goToNextPhase()}
              >
                {i18next.t('next', { lng: this.props.language, ns: 'questionnaire' })}
              </button>
            </p>
          </Col>
        </Row>

        <p>
          <img className={styles.illustration} src={illustration} />
        </p>
      </section>
    )
  }

  renderConfidentialityAgreement() {
    return (
      <section className={styles.introductionText}>
        <h1>
          {i18next.t('confidentiality_agreement', {
            lng: this.props.language,
            ns: 'questionnaire'
          })}
        </h1>

        <Row>
          <Col sm={8} smOffset={2} style={{ textAlign: 'left' }}>
            <strong>
              {i18next.t('confidentiality_agreement_subtitle', {
                lng: this.props.language,
                ns: 'questionnaire'
              })}
            </strong>

            <div
              className={styles.confidentialityAgreement}
              dangerouslySetInnerHTML={{
                __html: linkifyHtml(
                  i18next
                    .t('confidentiality_agreement_text', {
                      lng: this.props.language,
                      ns: 'questionnaire'
                    })
                    .replace(/\\n/g, '<br/>')
                )
              }}
            />
          </Col>
        </Row>

        <p>
          <label className={styles.checkbox}>
            <input
              type="checkbox"
              name="consentGiven"
              checked={this.state.consentGiven}
              onChange={this.toggleConsentGiven}
            />
            &nbsp;{i18next.t('confidentiality_agreement_consent_label', {
              lng: this.props.language,
              ns: 'questionnaire'
            })}
          </label>
        </p>

        <p>
          <button
            id="next-button"
            className={styles.button}
            onClick={() => this.props.goToNextPhase()}
            disabled={!this.state.consentGiven}
          >
            {i18next.t('next', { lng: this.props.language, ns: 'questionnaire' })}
          </button>
        </p>
      </section>
    )
  }

  renderPersonalInformationForm() {
    const sexes = [
      { value: 'f', label: 'female' },
      { value: 'm', label: 'male' },
      { value: 'o', label: 'other' }
    ]

    return (
      <section className={styles.introductionText}>
        <h1>
          {i18next.t('personal_information', { lng: this.props.language, ns: 'questionnaire' })}
        </h1>

        <Row>
          <Col sm={8} smOffset={2} md={6} mdOffset={3}>
            <div className={styles.informationForm}>
              <div
                className={styles.informationFormGroup}
                style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
              >
                <FormGroup>
                  <ControlLabel>
                    {i18next.t('given_name', { lng: this.props.language, ns: 'questionnaire' })}
                    <span className={styles.isMandatory}>*</span>
                  </ControlLabel>

                  <FormControl
                    type="text"
                    value={this.state.information.givenName}
                    placeholder={i18next.t('given_name', {
                      lng: this.props.language,
                      ns: 'questionnaire'
                    })}
                    name="givenName"
                    onChange={this.onChange.bind(this)}
                    autoComplete="off"
                  />
                </FormGroup>

                <FormGroup>
                  <ControlLabel>
                    {i18next.t('family_name', { lng: this.props.language, ns: 'questionnaire' })}
                    <span className={styles.isMandatory}>*</span>
                  </ControlLabel>

                  <FormControl
                    type="text"
                    value={this.state.information.familyName}
                    placeholder={i18next.t('family_name', {
                      lng: this.props.language,
                      ns: 'questionnaire'
                    })}
                    name="familyName"
                    onChange={this.onChange.bind(this)}
                    autoComplete="off"
                  />
                </FormGroup>

                <FormGroup>
                  <ControlLabel>
                    {i18next.t('age', { lng: this.props.language, ns: 'questionnaire' })}
                  </ControlLabel>

                  <FormControl
                    type="number"
                    value={this.state.information.age}
                    placeholder={i18next.t('age', {
                      lng: this.props.language,
                      ns: 'questionnaire'
                    })}
                    name="age"
                    min={0}
                    onChange={this.onChange.bind(this)}
                    autoComplete="off"
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>
                    {i18next.t('sex', { lng: this.props.language, ns: 'questionnaire' })}
                  </ControlLabel>

                  {sexes.map((s, key) => (
                    <Radio
                      key={key}
                      checked={this.state.information.sex === s.value}
                      name="sex"
                      readOnly
                      onClick={this.onChange.bind(this)}
                      value={s.value}
                    >
                      {i18next.t(s.label, { lng: this.props.language, ns: 'questionnaire' })}
                    </Radio>
                  ))}
                </FormGroup>

                <small className={styles.isMandatoryDescription}>
                  <span className={styles.isMandatory}>*</span>{' '}
                  {i18next.t('mandatory_description', {
                    lng: this.props.language,
                    ns: 'questionnaire'
                  })}
                </small>
              </div>
            </div>
          </Col>
        </Row>

        <p style={{ textAlign: 'center' }}>
          <button
            id="next-button"
            className={styles.button}
            disabled={!this.state.isInformationFormValid}
            onClick={e => this.submit(e)}
          >
            {i18next.t('next', { lng: this.props.language, ns: 'questionnaire' })}
          </button>
        </p>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/WopiSetup.js